var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("mandate.details_collection") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                {
                  staticClass:
                    "min-w-100 justify-content-start align-items-center",
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-start mt-3",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2 mr-2",
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "back-button btnFilter_2",
                          on: {
                            click: function ($event) {
                              return _vm.getCollection()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-solid fa-rotate-right" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.listItemsCollection.length > 0
                ? [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "mt-3", attrs: { cols: "12" } },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.mandate_info"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.unique_mandate_rf"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .UMR || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.mandate_type"
                                                ),
                                                inputValue:
                                                  _vm.$t(
                                                    "mandate.mandate_type_" +
                                                      _vm.listItemsCollection[0]
                                                        .TypeMandate
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.sign_mandate_date"
                                                ),
                                                inputValue:
                                                  _vm.formatDateShort(
                                                    _vm.listItemsCollection[0]
                                                      .SigningMdDate
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t(
                                        "mandate.details_transactions"
                                      ),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.status_collection"
                                                ),
                                                inputValue:
                                                  _vm.$t(
                                                    "mandate.status_collection_" +
                                                      _vm.listItemsCollection[0]
                                                        .Status
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.end_to_end_id"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .EndToEndId || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.schema_code"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .SchemaCode || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.collection_type"
                                                ),
                                                inputValue:
                                                  _vm.$t(
                                                    "mandate.collection_type_" +
                                                      _vm.listItemsCollection[0]
                                                        .TypeTransaction
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.amt"),
                                                inputValue:
                                                  _vm.formatCurrency(
                                                    _vm.listItemsCollection[0]
                                                      .Amount
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.date_due"),
                                                inputValue:
                                                  _vm.formatDateShort(
                                                    _vm.listItemsCollection[0]
                                                      .DueDate
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.date_settlement"
                                                ),
                                                inputValue:
                                                  _vm.formatDateShort(
                                                    _vm.listItemsCollection[0]
                                                      .SettlementDate
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.date_debit"),
                                                inputValue:
                                                  _vm.formatDateShort(
                                                    _vm.listItemsCollection[0]
                                                      .DebitDate
                                                  ) || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_ref"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrRefCollection || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.purpose"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .Purpose || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.purpose_category"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .PurposeCategory || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.remittance_info"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .RemittanceInfo || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.rsn_mandate_amendment"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .ReasonMandate || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.reject_reason"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .RejectionReason || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.reject_code"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .RejectionCode || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.cdtr_info"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_name"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrName !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrName
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_id"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrId !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrId
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.cdtr_addrss"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrAddr !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrAddr
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_city"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrCity !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrCity
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_ctry"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrCountry !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrCountry
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.cdtr_rf_pty_id_cd"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrRef !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrRef
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "mandate.cdtr_rf_pty_nm"
                                                ),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrRefName !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrRefName
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.cdtr_iban"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .CdtrIBAN !== "$NotFound"
                                                    ? _vm.listItemsCollection[0]
                                                        .CdtrIBAN
                                                    : "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.dbtr_info"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.dbtr_name"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .DbtrName || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("mandate.dbtr_iban"),
                                                inputValue:
                                                  _vm.listItemsCollection[0]
                                                    .DbtrIBAN || "-",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", {
                                          staticClass: "mb-5",
                                          attrs: { sm: "4" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr", { staticClass: "mx-auto" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "history-no-padding" },
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("mandate.history"),
                                      isTitleUpperCase: false,
                                    },
                                  },
                                  [
                                    _vm.listItemsCollection.length > 0
                                      ? _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table table-striped w-100",
                                          },
                                          [
                                            _c(
                                              "tbody",
                                              [
                                                _c("tr", [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.status_collection"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "text-center w-25",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "mandate.date_action"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.listItemsCollection[0]
                                                    .History,
                                                  function (c) {
                                                    return _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center w-25",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              class: [
                                                                "chip",
                                                                "chip--" +
                                                                  _vm.statusVariant(
                                                                    c.StatusHistory
                                                                  ),
                                                              ],
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "mandate.status_collection_" +
                                                                      c.StatusHistory
                                                                  ) || "-"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-center w-25",
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatDate(
                                                                  c.ActionDate
                                                                ) || "-"
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    ["7"].includes(_vm.listItemsCollection[0].Status)
                      ? _c(
                          "b-row",
                          {
                            staticClass: "form-group justify-content-end mt-5",
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "2" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", size: "lg" },
                                    on: { click: _vm.editStatusReversal },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-solid fa-turn-down-right",
                                      attrs: { size: "17px" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("mandate.reverse"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }